window.ls = window.ls || window.localStorage;

try {
    // Test
    const mod = 'localStorageTest';

    window.localStorage.setItem(mod, mod);
    window.localStorage.removeItem(mod);
} catch (e) {
    window.ls = {
        _data: {},
        setItem: function (id, val) { return this._data[id] = String(val); },
        getItem: function (id) { return this._data.hasOwnProperty(id) ? this._data[id] : undefined; },
        removeItem: function (id) { return delete this._data[id]; },
        clear: function () { return this._data = {}; }
    };
}

export function set(key, value) {
    window.ls.setItem(key, value);
}

export function get(key) {
    return window.ls.getItem(key);
}


// WEBPACK FOOTER //
// ./app/api/localStore.js